export interface CreateSupplierFormValues {
  approved_supplier: boolean;
  preferred_supplier: boolean;
  critical_supplier: boolean;
  name: string;
  external_id: string;
  owner_user_id: string;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
  contact_notes: string;
}

export const createSupplierDefaultValues: CreateSupplierFormValues = {
  approved_supplier: false,
  preferred_supplier: false,
  critical_supplier: false,
  name: "",
  external_id: "",
  owner_user_id: "",
  contact_name: "",
  contact_email: "",
  contact_phone: "",
  contact_notes: "",
};

type CreateSupplierErrorTarget = keyof CreateSupplierFormValues | "root.server";

export const parseCreateSupplierError = (error: unknown): { target: CreateSupplierErrorTarget; message: string } => {
  const detail = (error as { data?: { detail?: unknown } })?.data?.detail;
  if (
    detail &&
    typeof detail === "object" &&
    !Array.isArray(detail) &&
    "code" in detail &&
    detail.code === "supplier_external_id_conflict"
  ) {
    return { target: "external_id", message: "This Supplier ID is already in use." };
  }
  if (Array.isArray(detail)) {
    const fieldError = detail.find(item => {
      const field = (item as { loc?: unknown[] }).loc?.at(-1);
      return typeof field === "string" && field in createSupplierDefaultValues;
    }) as { loc?: unknown[]; msg?: string } | undefined;
    const field = fieldError?.loc?.at(-1);
    if (typeof field === "string" && field in createSupplierDefaultValues) {
      return {
        target: field as keyof CreateSupplierFormValues,
        message: fieldError?.msg || "Check this field.",
      };
    }
  }
  return { target: "root.server", message: "Supplier could not be created. Check the details and try again." };
};

export const optional = (value: string) => value.trim() || null;
